export default "__VITE_ASSET__ca232211__"